import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ICONS from "../../../../../assets/Icons";
import AssociateAccountBankEdit from "../../../../../containers/Accounts/BeneficiaryEditAccount/AssociateAccountBankEdit";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import BankDetails from "../../../../_utils/AccountCreationComponents/BankDetails";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import { useBankVerification } from "../../../../verification/hooks/useBankVerification";
import TaxAccountDetailsPopup from "../../TaxAccountDetailsPopup";
import CommonLayout from "../../../../_utils/CommonLayout";

const TaxAccountStepBank = (props) => {
  const {
    payload,
    setPayload,
    setIsNextDisabled,
    activeStep,
    bankLookupNext,
    setBankLookupNext,
    isIFSCValid,
    isBankError,
    verifiedPan,
    previousId,
    hideBankBlock,
    setBankUserInfo,
    setShowAccInfo,
    setBankIsArchived,
    setBankIsApproved,
    setBankIsDennied,
    setBankIsPending,
    setBankAccountType,
    setActive,
    setBankHideBlock,
  } = props;

  const bankState = useSelector((s) => s.beneAllVerification);
  const benebankLookData = bankState?.beneLookData;
  const beneLookLoading = bankState?.beneLookLoading;
  const accounts = benebankLookData?.beneficiary_accounts || [];

  const [activeTab, setActiveTab] = useState("Active");
  const [isApprovedState, setIsApprovedState] = useState([]);
  const [slideDirection, setSlideDirection] = useState("right");
  const [virtualAccount, setVirtualAccount] = useState(false);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);
  const [taxAccountDetails, setTaxAccountDetails] = useState(false);
  const [taxAccountId, setTaxAccountId] = useState("");

  const {
    verified,
    accountHolder,
    virtualAccount: detectedVirtualAccount,
    error,
  } = useBankVerification({
    accountNumber: payload.bank_account,
    ifsc: payload.ifsc_code,
    legalName: payload.legal_name,
  });

  const hasBankAssociated =
    (accounts?.length || GlobalConfiguration?.lengthCheckZero) >
    GlobalConfiguration?.lengthCheckZero;

  const lookupLoading = beneLookLoading;

  const addSpacesToNumber = (number) => {
    return number?.replace(/(.{4})/g, "$1 ").trim();
  };

  const haveAcheived = accounts.find(
    (val) => val?.approval_status === "archived",
  );
  const haveApproved = accounts.find(
    (val) => val?.approval_status === "approved",
  );
  const haveDennied = accounts.find((val) => val?.approval_status === "denied");
  const havePending = accounts.find(
    (val) => val?.approval_status === "pending",
  );
  const haveBlock = accounts.find((val) => val?.approval_status === "blocked");
  const haveRejected = accounts.find(
    (val) => val?.approval_status === "rejected",
  );

  const shouldShowNoAssociatedMsg =
    !lookupLoading &&
    verified === true &&
    !virtualAccount &&
    payload.bank_account?.length >= GlobalConfiguration?.accountnormalLength &&
    payload.ifsc_code?.length === GlobalConfiguration?.ifscLength &&
    accounts.length === GlobalConfiguration?.lengthCheckZero;

  const details =
    !beneLookLoading &&
    benebankLookData?.status === undefined &&
    !isBankError &&
    isIFSCValid &&
    !virtualAccount;

  const isBankLinkedAccount = accounts.some(
    (a) =>
      a.pan_no === payload.panNumber &&
      a.bank_acc_no === payload.bank_account &&
      a.ifsc_code === payload.ifsc_code,
  );

  const shouldBlockDuplicate = isBankLinkedAccount && isIFSCValid;

  useEffect(() => {
    if (!accounts.length) return;

    const linked = accounts.filter((a) => a.id === previousId);
    const others = accounts.filter((a) => a.id !== previousId);

    setIsApprovedState([...linked, ...others]);
  }, [accounts, previousId]);

  useEffect(() => {
    if (verified) {
      setBankVerificationStatus(true);

      setPayload((prev) => ({
        ...prev,
        acc_holder_name: accountHolder,
        skip_account_verification: "N",
      }));

      if (detectedVirtualAccount) {
        setVirtualAccount(true);
      }
    }

    if (error || isBankError) {
      setBankVerificationStatus(false);
    }
  }, [verified, accountHolder, detectedVirtualAccount, error, isBankError]);

  useEffect(() => {
    const isAccountValid =
      payload.bank_account?.length >= GlobalConfiguration?.accountnormalLength;

    const isIfscValid =
      payload.ifsc_code?.length === GlobalConfiguration?.ifscLength;

    if (!isAccountValid || !isIfscValid) {
      setIsApprovedState([]);
    }
  }, [payload.bank_account, payload.ifsc_code]);

  const ActiveData = () => {
    setActive(false);
    setBankIsDennied(false);
    setBankIsApproved(false);
    setBankIsArchived(false);

    if (activeTab === "Inactive") setSlideDirection("left");

    setActiveTab("Active");
    setBankIsPending(false);
    setBankAccountType({ type: "", id: "" });
    setBankHideBlock(false);
    setShowAccInfo(false);
  };

  const DeactiveData = () => {
    setActive(true);
    setBankIsDennied(false);
    setBankIsApproved(false);
    setBankIsArchived(false);
    setBankIsPending(false);

    if (activeTab === "Active") setSlideDirection("right");

    setActiveTab("Inactive");
    setShowAccInfo(false);
    setBankAccountType({ type: "", id: "" });
  };

  return (
    <>
      {taxAccountDetails && (
        <>
          <TaxAccountDetailsPopup
            closeBeneAccountDetailModal={() => {
              setTaxAccountDetails(false);
            }}
            tax_account_id={taxAccountId}
            type={"tax_account_detail_modal"}
          />
        </>
      )}
      <div className="flex flex-col Qsmd:flex-row px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base Qsmd:gap-gap-xl gap-gap-md">
        <CommonLayout>
          <div className="w-width-full">
            {hideBankBlock && !isBankError && !virtualAccount && (
              <div className="bene_block_message_text">
                <img
                  src={ICONS?.ERROR_WHITE_CIRCLE}
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>To unblock this account, please contact customer support</p>
              </div>
            )}

            {isBankLinkedAccount && isIFSCValid && (
              <div className="bank_new_message_text_block_nonarchive">
                <img
                  src={ICONS?.ERROR_WHITE_CIRCLE}
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p>
                  Looks like this bank account is already linked to your PAN.
                  Please update either the bank details or your PAN to proceed.
                </p>
              </div>
            )}

            {virtualAccount && isIFSCValid && (
              <div className="bene_new_message_text_crt">
                <img
                  src={ICONS?.ERROR_WHITE_CIRCLE}
                  alt="info"
                  className="h-icon-md mr-margin-md"
                />
                <div>
                  <span className="text-text-primary">
                    Virtual Account Detected
                  </span>
                  <br />
                  <ul className="list-disc px-padding-button-m py-padding-button-m">
                    <li>
                      Account could not be verified as it is virtual account
                    </li>
                    <li className="pt-padding-sm">
                      Please self verify and proceed with caution
                    </li>
                  </ul>
                </div>
              </div>
            )}

            <div className="h-fit w-full lg:max-w-[var(--create-box-width)]">
              <BankDetails
                payload={payload}
                setPayload={setPayload}
                BenEnableNextButton={setIsNextDisabled}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                setBankUserInfo={setBankUserInfo}
                setShowAccInfo={setShowAccInfo}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                virtualAccount={virtualAccount}
                isIFSCValid={isIFSCValid}
              />
            </div>
          </div>

          <div className="w-full flex flex-col pb-padding-md Qsmd:pb-padding-base">
            {shouldShowNoAssociatedMsg && (
              <div className="max-w-[var(--create-box-width)] bg-primary-card rounded-border-radius-md p-padding-md flex flex-col items-center">
                <div className="w-width-full h-height-full">
                  <p className="flex flex-col gap-gap-sm text-text-primary text-base font-semibold">
                    Associated Accounts
                  </p>

                  <div className="text-text-secondary text-xs mt-margin-md">
                    <p className="font-semibold text-sm mb-margin-xs text-text-primary">
                      No associated accounts found
                    </p>
                    <p>
                      There are no existing accounts that are associated with
                      the bank details provided. You can proceed to create a new
                      account.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {!lookupLoading && hasBankAssociated && (
              <>
                <ConfirmBtnAccCreation
                  isButtonDisabled={shouldBlockDuplicate}
                  status={benebankLookData?.status}
                  isIFSCValid={isIFSCValid}
                  isBankError={isBankError}
                  lookupNext={bankLookupNext}
                  nextButtonEnabled={!bankLookupNext}
                  handleClick={() => {
                    if (shouldBlockDuplicate) return;
                    setBankLookupNext(true);
                  }}
                />

                <AssociateAccountBankEdit
                  ActiveData={ActiveData}
                  DeactiveData={DeactiveData}
                  setSlideDirection={setSlideDirection}
                  haveAcheived={haveAcheived}
                  haveDennied={haveDennied}
                  haveBlock={haveBlock}
                  haveRejected={haveRejected}
                  haveApproved={haveApproved}
                  havePending={havePending}
                  isApprovedState={isApprovedState}
                  activeTab={activeTab}
                  slideDirection={slideDirection}
                  verifiedPan={verifiedPan}
                  beneLookLoading={beneLookLoading}
                  previousId={previousId}
                  addSpacesToNumber={addSpacesToNumber}
                  details={details}
                  type="taxDetails"
                  setAccountId={setTaxAccountId}
                  setAccoutDetails={setTaxAccountDetails}
                />
              </>
            )}
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default TaxAccountStepBank;
